import config from '../config/custom'
import axios from 'axios'
import { message } from 'antd'
import { reconnect } from '../utils/sockets'

export const SIGN_REQUESTED = 'auth/SIGN_REQUESTED'
export const SIGN_FAILED = 'auth/SIGN_FAILED'
export const SIGN_IN = 'auth/SIGN_IN'
export const SIGN_OUT = 'auth/SIGN_OUT'
export const UNAUTHORIZE = 'auth/UNAUTHORIZE'

let initialState = {
  user: undefined,
  permissions: undefined,
  loading: false,
  error: false,
  unauthorized: false,
}

const storageValues = [
  { name: 'user', parse: true },
  { name: 'permissions', parse: true },
]

storageValues.forEach(i => {
  const localValue = localStorage.getItem(i.name)

  if (localValue) {
    initialState[i.name] = i.parse ? JSON.parse(localValue) : localValue
  }
})

if (!initialState.permissions) {
  initialState.user = undefined
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false
      }

    case SIGN_FAILED:
      return {
        ...state,
        loading: false,
        error: true
      }

    case SIGN_IN:
      localStorage.setItem('user', JSON.stringify(action.user))
      localStorage.setItem('permissions', JSON.stringify(action.permissions))

      reconnect()

      return {
        ...state,
        user: action.user,
        permissions: action.permissions,
        loading: false,
        unauthorized: false,
      }

    case SIGN_OUT:
      localStorage.removeItem('user')
      localStorage.removeItem('permissions')

      return {
        ...state,
        user: undefined,
        permissions: undefined
      }

    case UNAUTHORIZE:
      return {
        ...state,
        unauthorized: true
      }


    default:
      return state
  }
}

export const signInWithGoogle = (credential) => {
  return (dispatch) => {
    dispatch({ type: SIGN_REQUESTED })

    axios.put(`${config.baseUrl}/entrance/login-with-google`, null, {
      withCredentials: true,
      data: credential
    })
      .then(response => {
        dispatch({
          type: SIGN_IN,
          user: response.data.user,
          permissions: response.data.permissions
        })
      })
      .catch(error => {
        dispatch({ type: SIGN_FAILED })

        if (error.response && error.response.status === 401) {
          message.error('El usuario que ingresaste no tiene acceso')
        }
      })
  }
}

export const signIn = (username, password) => {
  return (dispatch) => {
    dispatch({ type: SIGN_REQUESTED })

    axios.put(`${config.baseUrl}/entrance/login`, null, {
      withCredentials: true,
      data: {
        username,
        password,
      }
    })
      .then(response => {
        dispatch({
          type: SIGN_IN,
          user: response.data.user,
          permissions: response.data.permissions
        })
      })
      .catch((error) => {
        dispatch({ type: SIGN_FAILED })
        if (error.response && error.response.status === 401) {
          message.error('El usuario que ingresaste no tiene acceso')
        } else {
          message.error('Verifica tus datos')
        }
      })
  }
}

export const signOut = () => {
  return (dispatch) => {
    axios.get(`${config.baseUrl}/account/logout`, {
      withCredentials: true
    })
      .then(() => {
        dispatch({ type: SIGN_OUT })
      })
      .catch(() => {
        //
      })
  }
}

export const unauthorize = () => {
  return (dispatch) => {
    dispatch({ type: UNAUTHORIZE })
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth.js